import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { TabLineButton } from '../../../styles/button.style';
import { useRetroactiveCargoMode } from '../../../context/RetroactiveCargoModeContext';
import { useAuthStore } from '../../../context/AuthContext';
import { RoleTypeEnum } from '../../../enums/roleTypeEnum';
import { ToggleWrapper, ToggleLabel, InfoIcon } from './RetroactiveCargoModeToggle.style';

interface RetroactiveCargoModeToggleProps {
    showLabel?: boolean;
    compact?: boolean;
}

const RetroactiveCargoModeToggle: React.FC<RetroactiveCargoModeToggleProps> = ({ showLabel = true, compact = false }) => {
    const { isRetroactiveCargoModeEnabled, toggleRetroactiveCargoMode } = useRetroactiveCargoMode();
    const { role } = useAuthStore();

    // Only super users (Admin, FleetPerformanceAnalyst, ShipOperator) can access this mode
    const canAccessRetroactiveMode = (): boolean => {
        if (!role) return false;
        return (
            role.roleType === RoleTypeEnum.Admin ||
            role.roleType === RoleTypeEnum.FleetPerformanceAnalyst ||
            role.roleType === RoleTypeEnum.ShipUser ||
            role.roleType === RoleTypeEnum.ShipOperator
        );
    };

    if (!canAccessRetroactiveMode()) {
        return null;
    }

    if (compact) {
        return (
            <TabLineButton isSelected={isRetroactiveCargoModeEnabled} onClick={toggleRetroactiveCargoMode} title="Toggle Retroactive Cargo Mode">
                <FontAwesomeIcon icon={isRetroactiveCargoModeEnabled ? 'unlock' : 'lock'} />
            </TabLineButton>
        );
    }

    return (
        <ToggleWrapper>
            <TabLineButton isSelected={isRetroactiveCargoModeEnabled} onClick={toggleRetroactiveCargoMode}>
                <FontAwesomeIcon icon={isRetroactiveCargoModeEnabled ? 'unlock' : 'lock'} />
                {showLabel && <ToggleLabel>Retroactive Cargo Mode</ToggleLabel>}
            </TabLineButton>
            {isRetroactiveCargoModeEnabled && (
                <ToggleLabel style={{ color: '#ff9800', marginLeft: '8px', fontSize: '0.85em' }}>
                    (Cargo events can be edited after departure)
                </ToggleLabel>
            )}
        </ToggleWrapper>
    );
};

export default RetroactiveCargoModeToggle;
